/**
 * ====================================================================
 * CONFIGURATION UNIFIÉE PEELOCHAT DASHBOARD - VERSION SIMPLIFIÉE
 * ====================================================================
 */

// ====================================================================
// DÉTECTION DE L'ENVIRONNEMENT
// ====================================================================

// Vérification sécurisée de l'environnement
const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// Environnement SANDBOX (dashboard de test, miroir exact de la prod) : SEULE différence avec
// la prod = le copilote Moo tape sur le backend cloné "MooSandbox" (port 4166, moonext.aipeelo.xyz)
// au lieu du Moo de production, pour pouvoir développer/tester Moo sans casser le live.
const isSandbox = typeof window !== 'undefined' && window.location.hostname === 'sandbox.peelo.io';

// ====================================================================
// CONFIGURATION API PRINCIPALE
// ====================================================================

// URL de l'API principale - Direct vers l'API peelo.io
// URL de l'API principale 
// Sur sandbox.peelo.io, on tape le BACKEND SANDBOX (clone de dashboard.js lancé sur :4263,
// proxifié par nginx sous /apibk) pour tester des endpoints sans toucher le backend de prod.
// En prod (branche main) cette clé reste https://api.peelo.io.
export const apiBaseUrl = isLocalhost
  ? 'http://localhost:4163'
  : isSandbox
    ? 'https://sandbox.peelo.io/apibk'
    : 'https://api.peelo.io';

export const actionsApiBaseUrl = isLocalhost 
  ? 'http://localhost:4165' 
  : 'https://actions.peelo.io';

// ====================================================================
// CONFIGURATION E-COMMERCE
// ====================================================================

export const ecommerceApiBaseUrl = isLocalhost
  ? 'https://apicommerce.aipeelo.xyz'
  : 'https://apicommerce.aipeelo.xyz';

export const ecommerceDashboardUrl = isLocalhost
  ? 'https://admin.peelo.shop' 
  : 'https://admin.peelo.shop';

export const mainDashboardUrl = isLocalhost
  ? 'https://localhost:8080'
  : 'https://dashboard.peelo.io';

// ====================================================================
// CONFIGURATION JARVIS
// ====================================================================

export const jarvisApiBaseUrl = 'https://jarvis.aipeelo.xyz';

export const mooApiBaseUrl = isSandbox
  ? 'https://moonext.aipeelo.xyz'        // Moo SANDBOX (clone classique de aibuilder/, port 4166)
  : isLocalhost
    ? 'http://localhost:4164'
    : 'https://moo.aipeelo.xyz';          // Moo PROD (aibuilder/, port 4164)

// ====================================================================
// CONFIGURATION INSTAGRAM (automations "commentaire => DM")
// ====================================================================
// Service sandbox InstagramSandbox (port 4170), proxifié par nginx sous
// https://sandbox.peelo.io/instagram/. En prod il faudra un vrai domaine.

export const instagramApiBaseUrl = isSandbox
  ? 'https://sandbox.peelo.io/instagram'
  : isLocalhost
    ? 'http://localhost:4170/instagram'
    : 'https://dashboard.peelo.io/instagram'; // prod : proxifié par nginx vers le service (port 4170)

// ====================================================================
// CONFIGURATION CRYPTO
// ====================================================================

export const cryptoSecret = process.env.VUE_APP_CRYPTO_SECRET || 'peelo-dashboard-secret-key-2024';

// ====================================================================
// CONFIGURATION DE DÉVELOPPEMENT
// ====================================================================

export const isDevelopment = isLocalhost;
export const isProduction = !isLocalhost; 